import styles from './Skillset.module.css';

// Images - AI Tools
import ClaudeCode_Logo_1x from './../../assets/HomePage/AITools/1ClaudeCode_Logo/ClaudeCode_Logo_1x.webp';
import ClaudeCode_Logo_2x from './../../assets/HomePage/AITools/1ClaudeCode_Logo/ClaudeCode_Logo_2x.webp';

import Codex_Logo_1x from './../../assets/HomePage/AITools/2Codex_Logo/Codex_Logo_1x.webp';
import Codex_Logo_2x from './../../assets/HomePage/AITools/2Codex_Logo/Codex_Logo_2x.webp';

import GitHubCopilot_Logo_1x from './../../assets/HomePage/AITools/3GitHubCopilot_Logo/GitHubCopilot_Logo_1x.webp';
import GitHubCopilot_Logo_2x from './../../assets/HomePage/AITools/3GitHubCopilot_Logo/GitHubCopilot_Logo_2x.webp';

import Cursor_Logo_1x from './../../assets/HomePage/AITools/4Cursor_Logo/Cursor_Logo_1x.webp';
import Cursor_Logo_2x from './../../assets/HomePage/AITools/4Cursor_Logo/Cursor_Logo_2x.webp';

import FigmaMake_Logo_1x from './../../assets/HomePage/AITools/5FigmaMake_Logo/FigmaMake_Logo_1x.webp';
import FigmaMake_Logo_2x from './../../assets/HomePage/AITools/5FigmaMake_Logo/FigmaMake_Logo_2x.webp';

import AdobeFirefly_Logo_1x from './../../assets/HomePage/AITools/6AdobeFirefly_Logo/AdobeFirefly_Logo_1x.webp';
import AdobeFirefly_Logo_2x from './../../assets/HomePage/AITools/6AdobeFirefly_Logo/AdobeFirefly_Logo_2x.webp';

import VercelV0_Logo_1x from './../../assets/HomePage/AITools/7VercelV0_Logo/VercelV0_Logo_1x.webp';
import VercelV0_Logo_2x from './../../assets/HomePage/AITools/7VercelV0_Logo/VercelV0_Logo_2x.webp';

// Images - Design Tools
import Figma_Logo_1x from './../../assets/HomePage/DesignTools/1Figma_Logo/Figma_Logo_1x.webp';
import Figma_Logo_2x from './../../assets/HomePage/DesignTools/1Figma_Logo/Figma_Logo_2x.webp';

import Ai_Logo_1x from './../../assets/HomePage/DesignTools/2Ai_Logo/Ai_Logo_1x.webp';
import Ai_Logo_2x from './../../assets/HomePage/DesignTools/2Ai_Logo/Ai_Logo_2x.webp';

import PS_Logo_1x from './../../assets/HomePage/DesignTools/3PS_Logo/PS_Logo_1x.webp';
import PS_Logo_2x from './../../assets/HomePage/DesignTools/3PS_Logo/PS_Logo_2x.webp';

import Xd_Logo_1x from './../../assets/HomePage/DesignTools/7Xd_Logo/Xd_Logo_1x.webp';
import Xd_Logo_2x from './../../assets/HomePage/DesignTools/7Xd_Logo/Xd_Logo_2x.webp';

import Pr_Logo_1x from './../../assets/HomePage/DesignTools/6Pr_Logo/Pr_Logo_1x.webp';
import Pr_Logo_2x from './../../assets/HomePage/DesignTools/6Pr_Logo/Pr_Logo_2x.webp';

import Ae_Logo_1x from './../../assets/HomePage/DesignTools/5Ae_Logo/Ae_Logo_1x.webp';
import Ae_Logo_2x from './../../assets/HomePage/DesignTools/5Ae_Logo/Ae_Logo_2x.webp';

import Id_Logo_1x from './../../assets/HomePage/DesignTools/4Id_Logo/Id_Logo_1x.webp';
import Id_Logo_2x from './../../assets/HomePage/DesignTools/4Id_Logo/Id_Logo_2x.webp';

// Images - Primary Technologies
import NextJS_Logo_1x from './../../assets/HomePage/PrimaryTechnologies/0NextJS_Logo/NextJS_Logo_1x.webp';
import NextJS_Logo_2x from './../../assets/HomePage/PrimaryTechnologies/0NextJS_Logo/NextJS_Logo_2x.webp';

import React_Logo_1x from './../../assets/HomePage/PrimaryTechnologies/1React_Logo/React_Logo_1x.webp';
import React_Logo_2x from './../../assets/HomePage/PrimaryTechnologies/1React_Logo/React_Logo_2x.webp';

import Angular_Logo_1x from './../../assets/HomePage/PrimaryTechnologies/2Angular_Logo/Angular_Logo_1x.webp';
import Angular_Logo_2x from './../../assets/HomePage/PrimaryTechnologies/2Angular_Logo/Angular_Logo_2x.webp';

import HTML_Logo_1x from './../../assets/HomePage/PrimaryTechnologies/3HTML_Logo/HTML_Logo_1x.webp';
import HTML_Logo_2x from './../../assets/HomePage/PrimaryTechnologies/3HTML_Logo/HTML_Logo_2x.webp';

import JS_Logo_1x from './../../assets/HomePage/PrimaryTechnologies/4JS_Logo/JS_Logo_1x.webp';
import JS_Logo_2x from './../../assets/HomePage/PrimaryTechnologies/4JS_Logo/JS_Logo_2x.webp';

import Ionic_Logo_1x from './../../assets/HomePage/PrimaryTechnologies/5Ionic_Logo/Ionic_Logo_1x.webp';
import Ionic_Logo_2x from './../../assets/HomePage/PrimaryTechnologies/5Ionic_Logo/Ionic_Logo_2x.webp';

import Net_Logo_1x from './../../assets/HomePage/PrimaryTechnologies/6Net_Logo/Net_Logo_1x.webp';
import Net_Logo_2x from './../../assets/HomePage/PrimaryTechnologies/6Net_Logo/Net_Logo_2x.webp';


export default function SkillsetComponent() {

    const functionalSkills = [
        {
            id: 1,
            name: 'Project Management'
        },
        {
            id: 2,
            name: 'Team Leading'
        },
        {
            id: 3,
            name: 'Client Handling'
        },
        {
            id: 4,
            name: 'Communication Skill'
        },
        {
            id: 5,
            name: 'Negotiation Skill'
        },
        {
            id: 6,
            name: 'Technology Trainer'
        },
        {
            id: 7,
            name: 'Delivery Management'
        },
        {
            id: 8,
            name: 'People Management'
        }
    ];

    const technicalSkills = [
        {
            id: 1,
            name: 'GenAI'
        },
        {
            id: 2,
            name: 'UI/UX Designing'
        },
        {
            id: 3,
            name: 'Web Designing'
        },
        {
            id: 4,
            name: 'Web Development'
        },
        {
            id: 5,
            name: 'Cross-Platform Mobile Development'
        }
    ];

    
    const aiTools = [
        {
            id: 1,
            name: 'Claude Code',
            image1x: ClaudeCode_Logo_1x,
            image2x: ClaudeCode_Logo_2x,
            alt: 'Logo of Claude Code'
        },
        {
            id: 2,
            name: 'Codex',
            image1x: Codex_Logo_1x,
            image2x: Codex_Logo_2x,
            alt: 'Logo of Codex'
        },
        {
            id: 3,
            name: 'GitHub Copilot',
            image1x: GitHubCopilot_Logo_1x,
            image2x: GitHubCopilot_Logo_2x,
            alt: 'Logo of GitHub Copilot'
        },
        {
            id: 4,
            name: 'Cursor',
            image1x: Cursor_Logo_1x,
            image2x: Cursor_Logo_2x,
            alt: 'Logo of Cursor'
        },        
        {
            id: 5,
            name: 'Figma Make',
            image1x: FigmaMake_Logo_1x,
            image2x: FigmaMake_Logo_2x,
            alt: 'Logo of Figma Make'
        },        
        {
            id: 6,
            name: 'Adobe Firefly',
            image1x: AdobeFirefly_Logo_1x,
            image2x: AdobeFirefly_Logo_2x,
            alt: 'Logo of Adobe Firefly'
        },        
        {
            id: 7,
            name: 'Vercel V0',
            image1x: VercelV0_Logo_1x,
            image2x: VercelV0_Logo_2x,
            alt: 'Logo of Vercel V0'
        },
    ];

    const designTools = [
        {
            id: 1,
            name: 'Figma',
            image1x: Figma_Logo_1x,
            image2x: Figma_Logo_2x,
            alt: 'Logo of Figma'
        },
        {
            id: 2,
            name: 'Adobe Illustrator',
            image1x: Ai_Logo_1x,
            image2x: Ai_Logo_2x,
            alt: 'Logo of Adobe Illustrator'
        },
        {
            id: 3,
            name: 'Adobe Photoshop',
            image1x: PS_Logo_1x,
            image2x: PS_Logo_2x,
            alt: 'Logo of Adobe Photoshop'
        },
        {
            id: 4,
            name: 'Adobe XD',
            image1x: Xd_Logo_1x,
            image2x: Xd_Logo_2x,
            alt: 'Logo of Adobe XD'
        },        
        {
            id: 5,
            name: 'Adobe Premier Pro',
            image1x: Pr_Logo_1x,
            image2x: Pr_Logo_2x,
            alt: 'Logo of Adobe Premier Pro'
        },        
        {
            id: 6,
            name: 'Adobe After Effects',
            image1x: Ae_Logo_1x,
            image2x: Ae_Logo_2x,
            alt: 'Logo of Adobe After Effects'
        },        
        {
            id: 7,
            name: 'Adobe InDesign',
            image1x: Id_Logo_1x,
            image2x: Id_Logo_2x,
            alt: 'Logo of Adobe InDesign'
        },
    ];

    const primaryTechs = [
        {
            id: 0,
            name: 'Next.js',
            image1x: NextJS_Logo_1x,
            image2x: NextJS_Logo_2x,
            alt: 'Logo of Next.js'
        },
        {
            id: 1,
            name: 'React',
            image1x: React_Logo_1x,
            image2x: React_Logo_2x,
            alt: 'Logo of React'
        },
        {
            id: 2,
            name: 'Angular',
            image1x: Angular_Logo_1x,
            image2x: Angular_Logo_2x,
            alt: 'Logo of Angular'
        },
        {
            id: 3,
            name: 'HTML/CSS',
            image1x: HTML_Logo_1x,
            image2x: HTML_Logo_2x,
            alt: 'Logo of HTML/CSS'
        },
        {
            id: 4,
            name: 'JavaScript',
            image1x: JS_Logo_1x,
            image2x: JS_Logo_2x,
            alt: 'Logo of JavaScript'
        },
        {
            id: 5,
            name: 'Ionic',
            image1x: Ionic_Logo_1x,
            image2x: Ionic_Logo_2x,
            alt: 'Logo of Ionic'
        },
        {
            id: 6,
            name: '.Net',
            image1x: Net_Logo_1x,
            image2x: Net_Logo_2x,
            alt: 'Logo of .Net'
        }
    ];

    const secondaryTechs = [
        {
            id: 1,
            name: 'Tailwind CSS'
        },
        {
            id: 2,
            name: 'Shadcn UI'
        },
        {
            id: 3,
            name: 'Azure DevOps'
        },
        {
            id: 4,
            name: 'Jira'
        },
        {
            id: 5,
            name: 'Agile'
        },
        {
            id: 6,
            name: 'FigJam'
        },
        {
            id: 7,
            name: 'Mural'
        },
        {
            id: 8,
            name: 'Bootstrap'
        },
        {
            id: 9,
            name: 'Google Material UI'
        },
        {
            id: 10,
            name: 'Python'
        },
        {
            id: 11,
            name: 'TypeScript'
        },
        {
            id: 12,
            name: 'Vue.JS'
        },
        {
            id: 13,
            name: 'C#'
        },
        {
            id: 14,
            name: 'ASP .Net MVC'
        },
        {
            id: 15,
            name: '.Net Web API'
        },
        {
            id: 16,
            name: 'React Native'
        },
        {
            id: 17,
            name: 'Flutter'
        },
        {
            id: 18,
            name: 'NodeJS'
        },
        {
            id: 19,
            name: 'Java'
        },
        {
            id: 20,
            name: 'Azure'
        },
        {
            id: 21,
            name: 'Google Firebase'
        },
        {
            id: 22,
            name: 'MongoDB'
        },
        {
            id: 23,
            name: 'SQL Server'
        }
    ];

    return (
        <section className={styles.skillsetSection + ' section animate__animated animate__fadeInUp animate__slow animate__delay-0.5s'}>
            <div className={styles.skillOverview}>
                <div className={styles.skillFunctional}>
                    <h2 className='D_HeadingSection'>Functional Skills</h2>
                    <div className={styles.skills + ' section_content'}>
                        {
                            functionalSkills.map(item => <span className={styles.chip} key={item.id}> {item.name} </span>)
                        }
                    </div>
                </div>
                <div className={styles.skillTechnical}>
                    <h2 className='D_HeadingSection'>Technical Skills</h2>
                    <div className={styles.skills + ' section_content'}>
                        {
                            technicalSkills.map(item => <span className={styles.chip} key={item.id}> {item.name} </span>)
                        }
                    </div>
                </div>
            </div>
            <div className={styles.skillPrimary}>
                <h2 className='D_HeadingSection'>AI Tools</h2>
                <div className={styles.skills_logos + ' section_content'}>
                    {
                        aiTools.map(item =>
                            <figure key={item.id}>
                                <picture>
                                    <source type="image/webp" media="(min-width:300px)" srcSet={item.image1x + ' 1x, ' + item.image2x + ' 2x'} alt={item.alt} />
                                    <img src={item.image1x} className={styles.skillLogoImg} alt={item.alt} />
                                </picture>
                                <figcaption className={styles.figcaption_skillLogo}> {item.name} </figcaption>
                            </figure>
                        )
                    }
                </div>
            </div>
            <div className={styles.skillPrimary}>
                <h2 className='D_HeadingSection'>Design Tools</h2>
                <div className={styles.skills_logos + ' section_content'}>
                    {
                        designTools.map(item =>
                            <figure key={item.id}>
                                <picture>
                                    <source type="image/webp" media="(min-width:300px)" srcSet={item.image1x + ' 1x, ' + item.image2x + ' 2x'} alt={item.alt} />
                                    <img src={item.image1x} className={styles.skillLogoImg} alt={item.alt} />
                                </picture>
                                <figcaption className={styles.figcaption_skillLogo}> {item.name} </figcaption>
                            </figure>
                        )
                    }
                </div>
            </div>
            <div className={styles.skillPrimary}>
                <h2 className='D_HeadingSection'>Primary Technologies</h2>
                <div className={styles.skills_logos + ' section_content'}>
                    {
                        primaryTechs.map(item =>
                            <figure key={item.id}>
                                <picture>
                                    <source type="image/webp" media="(min-width:300px)" srcSet={item.image1x + ' 1x, ' + item.image2x + ' 2x'} alt={item.alt} />
                                    <img src={item.image1x} className={styles.skillLogoImg} alt={item.alt} />
                                </picture>
                                <figcaption className={styles.figcaption_skillLogo}> {item.name} </figcaption>
                            </figure>
                        )
                    }
                </div>
            </div>
            <div className={styles.skillSecondary}>
                <h2 className='D_HeadingSection'>Secondary Technologies</h2>
                <div className={styles.skills + ' section_content'}>
                    {
                        secondaryTechs.map(item => <span className={styles.chip} key={item.id}> {item.name} </span>)
                    }
                </div>
            </div>
        </section>
    );
}